/*
 *   File : manage-reports.js
 *   Author URI : https://evoqins.com
 *   Description : upload and download reports
 *   Integrations : 
 *   Version : v1.1
 */

import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { format, subDays, subYears } from "date-fns";

// Components
import { NavigationHeader } from "../../Components/Header";
import { CustomTab } from "../../Components/Tab";
import { DownloadButton, GradientButton } from "../../Components/Cta";
import { CustomAmountInput, CustomDateRangePicker, CustomSearchSelectBox, CustomTextInput, DataTableContainer, DatePicker } from "../../Components/FormElements";
import { CustomLoader, EmptyScreen } from "../../Components/Other";
import APIService from "../../Services/api-service";
import { _uploadDocumentToS3 } from "../../Services/aws-service";

// Styles
import Colors from "../../Styles/color.module.scss";
import { Icon } from "../../Components/Icon";
import { useSelector } from "react-redux";


// Custom Data
const PAGE_NAVIGATION = [
	"Dashboard",
	"Manage Quiz"
];

const NOTIFICATION_TABS = [
	{
		id: 1,
		type: 'Systematic Order Report'
	},
	{
		id: 2,
		type: 'Transactional Report'
	},
	{
		id: 3,
		type: 'AUM report'
	}
];

const SIP_REPORT_TYPES = [
	{
		label: "SIP Registration detail",
		value: 1
	},
	{
		label: "SIP Cease Detail",
		value: 2
	},
	{
		label: "SIP Expiry Details",
		value: 3
	},
]

const SIP_REPORT_DATA = [
	{
		mf_name: "Quant Mutual Fund",
		investor_name: "ANSHU BALA",
		branch_name: "7C9A",
		folio_no: "50793978296",
		amount: 5000,
		phone: 9994742330,
		email: "anushu@gmail.com",
		zone: "Pune",
		region_name: "Bang"
	},
	{
		mf_name: "Quant Mutual Fund",
		investor_name: "ANSHU BALA",
		branch_name: "7C9A",
		folio_no: "50793978296",
		amount: 5000,
		phone: 9994742330,
		email: "anushu@gmail.com",
		zone: "Pune",
		region_name: "Bang"
	},
	{
		mf_name: "Quant Mutual Fund",
		investor_name: "ANSHU BALA",
		branch_name: "7C9A",
		folio_no: "50793978296",
		amount: 5000,
		phone: 9994742330,
		email: "anushu@gmail.com",
		zone: "Pune",
		region_name: "Bang"
	},
	{
		mf_name: "Quant Mutual Fund",
		investor_name: "ANSHU BALA",
		branch_name: "7C9A",
		folio_no: "50793978296",
		amount: 5000,
		phone: 9994742330,
		email: "anushu@gmail.com",
		zone: "Pune",
		region_name: "Bang"
	},
	{
		mf_name: "Quant Mutual Fund",
		investor_name: "ANSHU BALA",
		branch_name: "7C9A",
		folio_no: "50793978296",
		amount: 5000,
		phone: 9994742330,
		email: "anushu@gmail.com",
		zone: "Pune",
		region_name: "Bang"
	},
	{
		mf_name: "Quant Mutual Fund",
		investor_name: "ANSHU BALA",
		branch_name: "7C9A",
		folio_no: "50793978296",
		amount: 5000,
		phone: 9994742330,
		email: "anushu@gmail.com",
		zone: "Pune",
		region_name: "Bang"
	},
];

const AUM_TRANSACTION_MODE = [
	{ value: 1, label: 'Demat' },
	{ value: 2, label: 'Physical' },
	{ value: 3, label: 'Both' },
];
const AUM_SCHEME_TYPE = [
	{ value: 1, label: 'All' },
	{ value: 2, label: 'Equity' },
	{ value: 3, label: 'ETF' },
	{ value: 4, label: 'ELSS' },
];


function ManageReport() {

	const popupRef = useRef(null);
	const fileInputRef = useRef(null);
	const transactionRef = useRef(0);
	const ADMIN_PROFILE_DATA = useSelector(state => state.MT_ADMIN_STORE.ADMIN_PROFILE);

	const [tabIndex, setTabIndex] = useState(NOTIFICATION_TABS[0].id);
	const [downloadLoader, setDownloadLoader] = useState(false);
	const [sipOrderType, setSipOrderType] = useState("");
	const [sipStatusType, setSipStatusType] = useState("");
	const [zone, setZone] = useState("");
	const [region, setRegion] = useState("");
	const [branch, setBranch] = useState("");
	const [rm, setRm] = useState("");
	const [ap, setAp] = useState("");
	const [user, setUser] = useState("");
	const [selectedRange, setSelectedRange] = useState({
		startDate: subDays(new Date(), 31),
		endDate: new Date(),
		key: 'selection',
	});
	const [startDate, setStartDate] = useState(format(selectedRange.startDate, "dd-MM-yyyy"));

	const [endDate, setEndDate] = useState(format(selectedRange.endDate, "dd-MM-yyyy"));
	console.log('startDate', startDate, 'enddate', endDate);
	const [showDateFilter, setShowDateFilter] = useState(false);
	const [registrar, setRegistrar] = useState("");
	const [amc, setAmc] = useState("");
	const [scheme, setScheme] = useState("");
	const [folioNo, setFolioNo] = useState("");
	const [maxAmount, setMaxAmount] = useState("");
	const [minAmount, setMinAmount] = useState("");
	const [frequency, setFrequency] = useState("");
	const [transactionType, setTransactionType] = useState(null);
	const [aumDate, setAumDate] = useState(null);
	const [aumTransactionMode, setAumTransactionMode] = useState("");
	const [aumSchemeType, setAumSchemeType] = useState("");
	const [categoryType, setCategoryType] = useState("");

	const [reportData, setReportData] = useState(SIP_REPORT_DATA);

	const [sipReportData, setSipReportData] = useState([]);
	const [subTransactionFilter, setSubTransactionFilter] = useState([]);
	const [transactionReportData, setTransactionReportData] = useState([]);
	const [subTransactionType, setSubTrasactionType] = useState(null);
	const [aumReportData, setAumReportData] = useState([]);
	const [fileLoader, setFileLoader] = useState(false);
	const [pageNumber, setPageNumber] = useState(1);
	const [count, setCount] = useState(20);
	const [totalPages, setTotalPages] = useState();
	const [reportType, setReportType] = useState(SIP_REPORT_TYPES[0])


	//Dropdown data
	const [zoneList, setZoneList] = useState([]);
	const [regionList, setRegionList] = useState([]);
	const [branchList, setBranchList] = useState([]);
	const [rmList, setRmList] = useState([]);
	const [associateList, setAssociateList] = useState([]);
	// const [errors, setErrors] = useState({});

	const [statusTypeOptions, setStatusTypeOptions] = useState([]);
	const [systematicTypesOptions, setSystematicTypesOptions] = useState([]);
	const [frequencyOptions, setFrequencyOptions] = useState([]);
	const [transactionTypesOptions, setTransactionTypesOptions] = useState([]);
	const [amcList, setAmcList] = useState([]);
	const [schemeList, setSchemeList] = useState([]);
	const [apiLoader, setApiLoader] = useState(true);
	const [btnLoader, setBtnLoader] = useState(false);

	const [filterApplied, setFilterApplied] = useState(false);

	const SIP_REPORT_COLUMN = [
		{
			name: "AMC",
			selector: row => row.amc,
			sortable: false,
			width: "300px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px pe-5">
					{row.amc || "--"}
				</span>
			),
		},
		{
			name: "Scheme name",
			selector: row => row.scheme_name,
			sortable: false,
			width: "300px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px pe-5">
					{row.scheme_name || "--"}
				</span>
			),
		},
		{
			name: "Broker ID",
			selector: row => row.broker_id,
			sortable: false,
			width: "150px",
			cell: row => <span>{row.broker_id || "--"}</span>,
		},
		{
			name: "Cease Date",
			selector: row => row.cease_date,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.cease_date || "--"}</span>,
		},
		{
			name: "Client Code",
			selector: row => row.client_code,
			sortable: false,
			width: "160px",
			cell: row => <span>{row.client_code || "--"}</span>,
		},
		{
			name: "Client Name",
			selector: row => row.client_name,
			sortable: false,
			width: "280px",
			cell: row => <span>{row.client_name || "--"}</span>,
		},
		{
			name: "Transaction Code",
			selector: row => row.tran_code,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.tran_code || "--"}</span>,
		},
		{
			name: "Transaction No.",
			selector: row => row.tran_no,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.tran_no || "--"}</span>,
		},
		{
			name: "Total Installment",
			selector: row => row.total_installment,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.total_installment || "--"}</span>,
		},
		{
			name: "Installment Paid",
			selector: row => row.installment_paid,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.installment_paid || "--"}</span>,
		},
		{
			name: "Pending Installment",
			selector: row => row.pending_installment,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.pending_installment || "--"}</span>,
		},
		{
			name: "Previous Installment",
			selector: row => row.prev_installment_date,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.prev_installment_date || "--"}</span>,
		},
		{
			name: "Next Installment",
			selector: row => row.next_installment_date,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.next_installment_date || "--"}</span>,
		},
		{
			name: "Period Day",
			selector: row => row.period_day,
			sortable: false,
			width: "170px",
			cell: row => <span>{row.period_day || "--"}</span>,
		},
		{
			name: "Folio Number",
			selector: row => row.foliono,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.folio_no || "--"}</span>,
		},
		{
			name: "Investor Code",
			selector: row => row.investor_code,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.investor_code || "--"}</span>,
		},
		{
			name: "Investor PAN",
			selector: row => row.investor_pan,
			sortable: false,
			width: "180px",
			cell: row => <span>{row.investor_pan || "--"}</span>,
		},
		{
			name: "SIP Type",
			selector: row => row.sip_type,
			sortable: false,
			width: "250px",
			cell: row => <span>{row.sip_type || "--"}</span>,
		},
		{
			name: "SIP Start",
			selector: row => row.sip_start_date,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.sip_start_date || "--"}</span>,
		},
		{
			name: "SIP End",
			selector: row => row.sip_end_date,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.sip_end_date || "--"}</span>,
		},
		{
			name: "Amount",
			selector: row => row.amount,
			sortable: false,
			width: "170px",
			cell: row => <span>
				{
					row.amount ? `₹${row.amount.toLocaleString("en-IN")}` : "--"
				}
			</span>,
		},

		{
			name: "Reg Date",
			selector: row => row.reg_date,
			sortable: false,
			width: "170px",
			cell: row => <span>{row.reg_date || "--"}</span>,
		},
		{
			name: "Regl SNo.",
			selector: row => row.reglsno,
			sortable: false,
			width: "150px",
			cell: row => <span>{row.reglsno || "--"}</span>,
		}
	];

	const TRANSACTION_REPORT_COLUMN = [
		{
			name: "Scheme Name",
			selector: row => row.amc_name,
			sortable: false,
			width: "300px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px pe-5">
					{row.scheme_name || "--"}
				</span>
			),
		},
		{
			name: "Broker ID",
			selector: row => row.broker_id,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.broker_id || "--"}</span>,
		},
		{
			name: "Transaction Code",
			selector: row => row.transation_code,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.transation_code || "--"}</span>,
		},
		{
			name: "Transaction Date",
			selector: row => row.transaction_date,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.transaction_date || "--"}</span>,
		},
		{
			name: "Folio Number",
			selector: row => row.foliono,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.folio_no || "--"}</span>,
		},
		{
			name: "Investor Code",
			selector: row => row.investor_code,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.investor_code || "--"}</span>,
		},
		{
			name: "Investor Name",
			selector: row => row.investor_name,
			sortable: false,
			width: "300px",
			cell: row => <span>{row.investor_name || "--"}</span>,
		},
		{
			name: "Investor PAN",
			selector: row => row.investor_pan,
			sortable: false,
			width: "300px",
			cell: row => <span>{row.investor_pan || "--"}</span>,
		},
		{
			name: "Transaction Type",
			selector: row => row.transaction_type,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.transaction_type || "--"}</span>,
		},
		{
			name: "Sub Transaction Type",
			selector: row => row.sub_transaction_type,
			sortable: false,
			width: "200px",
			cell: row => <span>{row.sub_transaction_type || "--"}</span>,
		},
		{
			name: "Amount",
			selector: row => row.amount,
			sortable: false,
			width: "200px",
			cell: row => <span>
				{
					row.amount ? `₹${row.amount.toLocaleString("en-IN")}` : "--"
				}
			</span>,
		},
		{
			name: "Total Amount",
			selector: row => row.total_amount,
			sortable: false,
			width: "200px",
			cell: row => <span>
				{
					row.total_amount ? `₹${row.total_amount.toLocaleString("en-IN")}` : "--"
				}
			</span>,
		},
		{
			name: "Units",
			selector: row => row.units,
			sortable: false,
			width: "150px",
			cell: row => <span>{row.units || "--"}</span>,
		},
		{
			name: "TDS",
			selector: row => row.tds,
			sortable: false,
			width: "150px",
			cell: row => <span>{row.tds || "--"}</span>,
		},
		{
			name: "STT",
			selector: row => row.stt,
			sortable: false,
			width: "150px",
			cell: row => <span>{row.stt || "--"}</span>,
		},
		{
			name: "Client Code",
			selector: row => row.client_code,
			sortable: false,
			width: "150px",
			cell: row => <span>{row.client_code || "--"}</span>,
		},
		{
			name: "Stamp Duty",
			selector: row => row.stamp_duty,
			sortable: false,
			width: "150px",
			cell: row => <span>{row.stamp_duty || "--"}</span>,
		},
		{
			name: "Rate",
			selector: row => row.rate,
			sortable: false,
			width: "150px",
			cell: row => <span>{row.rate || "--"}</span>,
		},
		{
			name: "Status",
			selector: row => row.status,
			sortable: false,
			width: "150px",
			cell: row => <span>{row.status || "--"}</span>,
		}
	];

	const AUM_REPORT_COLUMN = [
		{
			name: "Investor Name",
			selector: row => row.investor_name,
			sortable: false,
			width: "260px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px pe-5">
					{row.investor_name || "--"}
				</span>
			),
		},
		{
			name: "Investor Code",
			selector: row => row.investor_code,
			sortable: false,
			width: "260px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px pe-5">
					{row.investor_code || "--"}
				</span>
			),
		},
		{
			name: "PAN",
			selector: row => row.investor_pan,
			sortable: false,
			width: "260px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px pe-5">
					{row.investor_pan || "--"}
				</span>
			),
		},
		{
			name: "Client Code",
			selector: row => row.client_code,
			sortable: false,
			width: "180px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{row.client_code || "--"}
				</span>
			),
		},
		{
			name: "Equity ELSS",
			selector: row => row.equity_elss,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					₹{row.equity_elss}
				</span>
			),
		},
		{
			name: "Equity Largecap",
			selector: row => row.equity_largecap,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.equity_largecap}`}
				</span>
			),
		},
		{
			name: "Equity Midcap",
			selector: row => row.equity_midcap,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.equity_midcap}`}
				</span>
			),
		},
		{
			name: "Equity Smallcap",
			selector: row => row.equity_smallcap,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.equity_smallcap}`}
				</span>
			),
		},
		{
			name: "Equity Other",
			selector: row => row.equity_other,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.equity_other}`}
				</span>
			),
		},
		{
			name: "Equity Sectoral Thematic",
			selector: row => row.equity_sectoral_thematic,
			sortable: false,
			width: "240px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.equity_sectoral_thematic}`}
				</span>
			),
		},
		{
			name: "Equity All",
			selector: row => row.equity_all,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.equity_all}`}
				</span>
			),
		},
		{
			name: "Debt Corporatebond",
			selector: row => row.debt_corporatebond,
			sortable: false,
			width: "240px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.debt_corporatebond}`}
				</span>
			),
		},
		{
			name: "Debt Gilt",
			selector: row => row.debt_gilt,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.debt_gilt}`}
				</span>
			),
		},
		{
			name: "Debt Liquid",
			selector: row => row.debt_liquid,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.debt_liquid}`}
				</span>
			),
		},
		{
			name: "Debt Moneymarket",
			selector: row => row.debt_moneymarket,
			sortable: false,
			width: "180px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.debt_moneymarket}`}
				</span>
			),
		},
		{
			name: "Debt Other",
			selector: row => row.debt_other,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.debt_other}`}
				</span>
			),
		},
		{
			name: "Debt All",
			selector: row => row.debt_all,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.debt_all}`}
				</span>
			),
		},
		{
			name: "Hybrid Arbitrage",
			selector: row => row.hybrid_arbitrage,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.hybrid_arbitrage}`}
				</span>
			),
		},
		{
			name: "Hybrid Other",
			selector: row => row.hybrid_other,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.hybrid_other}`}
				</span>
			),
		},
		{
			name: "Hybrid All",
			selector: row => row.hybrid_all,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.hybrid_all}`}
				</span>
			),
		},
		{
			name: "Solution Oriented",
			selector: row => row.solution_oriented,
			sortable: false,
			width: "160px",
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.solution_oriented}`}
				</span>
			),
		},
		{
			name: "Others",
			selector: row => row.others,
			width: "160px",
			sortable: false,
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{`₹${row.others}`}
				</span>
			),
		},
		// {
		// 	name: "ETF Units",
		// 	selector: row => row.etf_units,
		// 	width: "160px",
		// 	sortable: false,
		// 	cell: row => (
		// 		<span className="color-black e-poppins-regular e-font-16 line-height-24px">
		// 			{row.etf_units ? `₹${row.etf_units}` : "--"}
		// 		</span>
		// 	),
		// },
		// {
		// 	name: "ETF AUM",
		// 	selector: row => row.etf_aum,
		// 	width: "160px",
		// 	sortable: false,
		// 	cell: row => (
		// 		<span className="color-black e-poppins-regular e-font-16 line-height-24px">
		// 			{row.etf_aum ? `₹${row.etf_aum}` : "--"}
		// 		</span>
		// 	),
		// },

		{
			name: "Total AUM",
			selector: row => row.total_aum,
			width: "160px",
			sortable: false,
			cell: row => (
				<span className="color-black e-poppins-regular e-font-16 line-height-24px">
					{row.total_aum ? `₹${row.total_aum}` : "--"}
				</span>
			),
		},

	];

	const TABLE_STYLE = {
		table: {
			style: {
				padding: "0px",
				borderRadius: "16px",
				background: Colors.white,
				border: `1px solid ${Colors.bright_gray}`,
			},
		},
		tableBody: {
			style: {
				margin: '0px',
				marginTop: "0px !important"
			}
		},
		headRow: {
			style: {
				background: Colors.alice_blue,
				borderRadius: "16px 16px 0px 0px",
				border: "0",
				padding: "16px 32px",
				color: Colors.black,
				fontFamily: "Poppins-Regular",
				fontSize: "16px",
				lineHeight: "24px",
			}
		},
		rows: {
			style: {
				margin: "0",
				background: "transparent",
				border: "0 !important",
				borderTop: `1px solid ${Colors.bright_gray} !important`,
				borderRadius: "0",
				color: Colors.black,
				fontFamily: "Poppins-Regular",
				fontSize: "16px",
				lineHeight: "24px",
				padding: "16px 32px",
			},
		},
		cells: {
			style: {
				paddingLeft: '0px',
				paddingRight: '0px',
			},
		},
		headCells: {
			style: {
				paddingLeft: '0px',
				paddingRight: '0px',
			},
		},
		pagination: {
			style: {
				borderTop: `none `,
				color: Colors.outer_space,
				fontSize: '16px',
				fontFamily: "Poppins-Regular",
			},
		}
	};

	useEffect(() => {
		// API calls
		_getFilterData();
		_getZoneList();
		if (ADMIN_PROFILE_DATA.admin_type_id >= 5) {
			_getRegionList();
		}
		if (ADMIN_PROFILE_DATA.admin_type_id >= 6) {
			_getBranchList();
		}
		if (ADMIN_PROFILE_DATA.admin_type_id >= 7) {
			_getRMList();
		}
		// if (ADMIN_PROFILE_DATA.admin_type_id >= 8) {
		// 	_getAssociateList();
		// }
	}, []);

	

	useEffect(() => {
		if (tabIndex === 2) {
			_subTransactionFilter();
		}
	}, [tabIndex]);

	// useEffect(() => {
	// 	if (tabIndex === 3) {
	// 		_aumReportListData();
	// 	}
	// }, [tabIndex]);

	useEffect(() => {

		setSipOrderType("");
		setSipStatusType("");
		setSelectedRange({
			startDate: subDays(new Date(), 31),
			endDate: new Date(),
			key: 'selection',
		});
		// setZone("");
		// setRegion("");
		// setBranch("");
		// setRm("");
		// setAp("");
		setUser("");
		setRegistrar("");
		setAmc("");
		setScheme("");
		setFolioNo("");
		setMinAmount("");
		setMaxAmount("");
		// setTransactionType("");
		setAumTransactionMode("");
		setAumSchemeType("");
		setAumDate(null);
		setCategoryType("");

	}, [tabIndex]);

	useEffect(() => {
		if (zone) {
			// Getting Region list data
			_getRegionList();
		}
	}, [zone]);

	useEffect(() => {
		if (region) {
			// Getting branch list data
			_getBranchList();
		}
	}, [region]);

	useEffect(() => {
		if (branch) {
			// Getting RM list data
			_getRMList();
		}
	}, [branch]);

	useEffect(() => {
		if (rm) {
			// Getting AP list data
			_getAssociateList();
		}
	}, [rm]);

	useEffect(() => {
		if (amc) {
			// Getting Scheme list based on AMC
			_getSchemeList();
		}
	}, [amc]);

	// handle tab change
	const _handleTabChange = (tab_index) => {
		setTabIndex(tab_index);
		setFilterApplied(false);
		setApiLoader(false);
		setBtnLoader(false);
	};

	// handle download report
	const _handleDownloadReport = () => {

		setDownloadLoader(true);
		if (tabIndex === 1) {
			_downloadSystematicReport();
		} else if (tabIndex === 2) {
			_downloadTransactionalReport();
		} else if (tabIndex === 3) {
			_downloadAUMReport();
		}

	};


	// handle upload report 
	const _handleUploadReport = () => {
		fileInputRef.current.click();
	};

	// handle sip order type select
	const _handleSIPOrderTypeSelect = (value) => {
		setSipOrderType(value);
	};

	// handle sip status type select
	const _handleSIPStatusTypeSelect = (value) => {
		setSipStatusType(value);
	};

	// handle zone select
	const _handleZoneSelect = (value) => {
		setZone(value);
		// Clearing related field when zone changes
		setRegion("");
		setBranch("");
		setRm("");
		// setAp("");
	};

	const _handleRegionSelect = (value) => {
		setRegion(value);
		// Clearing related field when region changes
		setBranch("");
		setRm("");
		setAp("");
	};
	const _handleBranchSelect = (value) => {
		setBranch(value);
		// Clearing related field when branch changes
		setRm("");
		setAp("");
	};
	const _handleRMSelect = (value) => {
		setRm(value);
		// Clearing related field when rm changes
		setAp("");
	};
	const _handleAPSelect = (value) => {
		setAp(value);
	};
	const _handleUserSelect = (value) => {
		setUser(value);
	};

	const _handleShowDateFilter = () => {
		setShowDateFilter(!showDateFilter);
	};

	const _handleDateRangeChange = (newRange) => {
		setShowDateFilter(false);
		setStartDate(format(newRange.startDate, "dd-MM-yyyy"));
		setEndDate(format(newRange.endDate, "dd-MM-yyyy"));
		setSelectedRange(newRange);
	};


	const _handleClearDates = () => {
		setShowDateFilter(false);
		setSelectedRange({
			startDate: new Date(),
			endDate: new Date(),
			key: 'selection',
		});
		setStartDate("Start date");
		setEndDate("End date");
	};

	const _handleRegistrarSelect = (value) => {
		setRegistrar(value);
	};

	const _handleAMCSelect = (value) => {
		setAmc(value);
	};

	const _handleSchemeSelect = (value) => {
		setScheme(value);
	};

	const _handleFolioNoSelect = (value) => {
		setFolioNo(value);
	};

	const _handleFrequencySelect = (value) => {
		setFrequency(value);
	};

	const _handleTransactionTypeSelect = (value) => {
		setTransactionType(value);
	};

	const _handleMinAmountChange = (value) => {
		setMinAmount(value);
	};

	const _handleMaxAmountChange = (value) => {
		setMaxAmount(value);
	};

	const _handleAUMDateChange = (value) => {
		setAumDate(value);
	};

	const _handleAUMTransactionModeSelect = (value) => {
		setAumTransactionMode(value);
	};

	const _handleAUMSchemeTypeSelect = (value) => {
		setAumSchemeType(value);
	};

	const _handleCategoryTypeSelect = (value) => {
		setCategoryType(value);
	};


	// handler for page change
	function _nextPage() {
		setPageNumber(prevCount => prevCount + 1);
		setCount(prevCount => prevCount + 20);
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}

	// got to previous page
	function _previousPage() {
		setPageNumber(prevCount => prevCount - 1);
		setCount(prevCount => prevCount - 20);
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}

	// handle file upload
	const _handleFileUploadChange = (file) => {
		_fileHandler(file.target.value, file.target.files[0]);
		// Clearing file to upload same file or other files
		file.target.value = "";
	};

	// handle open download report popup
	const _handleOpenDownloadReportPopup = (report_url) => {
		const download_link = document.createElement('a');
		download_link.href = report_url;
		document.body.appendChild(download_link);
		download_link.click();
		document.body.removeChild(download_link);

		// Success message
		let report_name = tabIndex === 1 ? "Systematic" : tabIndex === 2 ? "Transaction" : "AUM";
		toast.dismiss();
		toast.success(`${report_name} Report Downloaded successfully`);
	}

	//  ==================================== //
	//  =========== API CAllS ============== //

	function _fileHandler(path, file) {
		var file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
		file_formatted = file_formatted[0].replace(/[\(\)\s]/g, ''); //returning path
		_fileUpload(file_formatted, file);
	};

	// API - file upload to S3
	const _fileUpload = (key, file) => {
		setFileLoader(true);
		let url = "general/file-upload";
		let body = {
			"key": `banner/${key}`,
			is_public: true
		}

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {
				// s3 helper
				await _uploadDocumentToS3(response.data, key, file).then((result) => {
					let api_url = tabIndex === 1 ? "upload-systematic-report" : tabIndex === 2 ? "upload-transaction-report" : "upload-aum-report";
					_uploadReport(response.data.view_info, api_url, tabIndex);
				}).catch(error => {
					toast.dismiss();
					toast.error(error, {
						type: "error",
					});
					setFileLoader(false);
				});
			} else {
				setFileLoader(false);
				toast.dismiss();
				toast.error(response, {
					type: "error",
				});
			}
		})
	};

	// API - Upload transaction report
	const _uploadReport = (file_url, api_url, type) => {
		let url = `reports/${api_url}`;
		let body = {
			'url': file_url
		};

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {
				let report_name = type === 1 ? "Systematic" : type === 2 ? "Transaction" : "AUM";
				toast.dismiss();
				toast.success(`${report_name} report uploaded successfully`);
			} else {
				toast.dismiss();
				toast.error(response.message);
			}
			setFileLoader(false);
		})
	};

	// API - get Zone List
	const _getZoneList = () => {
		let url = "client_mapping/zone/list";
		APIService(false, url).then(async (response) => {
			if (response.status_code === 200) {

				let zone_list = response.data.map((zone) => {
					return {
						...zone,
						label: zone.name,
						value: zone.code
					}
				});

				setZoneList(zone_list);
				setZone(zone_list[0]);
			} else {
				toast.dismiss();
				setZone("");
				toast.error(response);
			}
		});
	};

	// API - get Zone List
	const _getRegionList = () => {
		let url = "client_mapping/region/list";
		let body = {
			id: zone.id
		};

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {

				let region_list = response.data.map((region) => {
					return {
						...region,
						label: region.name,
						value: region.code
					}
				});

				setRegionList(region_list);
				if (ADMIN_PROFILE_DATA.admin_type_id >= 5) {
					setRegion(region_list[0]);
				}

			} else {
				setRegionList([]);
				setRegion("");
				toast.dismiss();
				toast.error(response);
			}
		});
	};

	// API - get Zone List
	const _getBranchList = () => {
		let url = "client_mapping/branch/list";
		let body = {
			id: region.id
		};

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {

				let branch_list = response.data.map((branch) => {
					return {
						...branch,
						label: branch.name,
						value: branch.code
					}
				});

				setBranchList(branch_list);
				if (ADMIN_PROFILE_DATA.admin_type_id >= 6) {
					setBranch(branch_list.length > 0 ? branch_list[0] : "");
				}

			} else {
				setBranchList([]);
				toast.dismiss();
				setBranch("");
				toast.error(response);
			}
		});
	};

	// API - get Zone List
	const _getRMList = () => {
		let url = "client_mapping/rm/list";
		let body = {
			id: branch.id
		};

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {

				let rm_list = response.data.map((rm) => {
					return {
						...rm,
						label: rm.name,
						value: rm.code
					}
				});

				setRmList(rm_list);
				if (ADMIN_PROFILE_DATA.admin_type_id >= 7) {
					setRm(rm_list.length > 0 ? rm_list[0] : "");
				}

			} else {
				setRmList([]);
				toast.dismiss();
				setRm("");
				toast.error(response);
			}
		});
	};

	// API - get Zone List
	const _getAssociateList = () => {
		let url = "client_mapping/ap/list";
		let body = {
			id: rm.id
		};

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {

				let ap_list = response.data.map((ap) => {
					return {
						...ap,
						label: ap.name,
						value: ap.code
					}
				});

				setAssociateList(ap_list);
				if (ADMIN_PROFILE_DATA.admin_type_id >= 8) {
					setAp(ap_list.length > 0 ? ap_list[0] : "");
				}
				// if (ap_list.length > 0) {
				// 	setAp(ap_list[0]);
				// }
			} else {
				setAssociateList([]);
				setAp("")
				toast.dismiss();
				toast.error(response);
			}
		});
	};

	// API - get Zone List
	const _getSchemeList = () => {
		let url = "reports/mf-list-filter-data";
		let body = {
			amc_id: amc.amc_id
		};

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {
				let scheme_list = response.data.map((scheme) => {
					return {
						...scheme,
						label: scheme.fund_name,
					}
				});

				setSchemeList(scheme_list);
			} else {
				toast.dismiss();
				toast.error(response);
			}
		});
	};

	// API - get Zone List
	const _getFilterData = () => {
		let url = "reports/report-filter-data";
		APIService(false, url).then(async (response) => {
			if (response.status_code === 200) {

				if (response.data.status_type.length !== 0) {
					let updated_list = response.data.status_type.map((item) => ({
						...item,
						label: item.name,
					}))
					setStatusTypeOptions(updated_list);
				}

				if (response.data.systematic_types.length !== 0) {
					let updated_list = response.data.systematic_types.map((item) => ({
						...item,
						label: item.name,
					}))
					setSystematicTypesOptions(updated_list);
				}

				if (response.data.frequency.length !== 0) {
					let updated_list = response.data.frequency.map((item) => ({
						...item,
						label: item.name,
					}))
					setFrequencyOptions(updated_list);
				}

				if (response.data.transaction_types.length !== 0) {
					let updated_list = response.data.transaction_types.map((item) => ({
						...item,
						label: item.label ?? item.name,
						value: item.id ?? item.value,
					}))
					setTransactionTypesOptions(updated_list);
					setTransactionType(updated_list[0])
				}

				if (response.data.amc_list.length !== 0) {
					let updated_list = response.data.amc_list.map((item) => ({
						...item,
						label: item.amc_name,
					}))
					setAmcList(updated_list);
				}

			} else {
				toast.dismiss();
				toast.error(response);
			}
		});
	};

	//Systematic Report List
	const _subTransactionFilter = () => {
		let url = "reports/sub-transaction-filter";

		APIService(false, url).then(async (response) => {
			if (response.status_code === 200) {
				const sub_type_list = Array.isArray(response.data)
					? response.data
					: (response.data.sub_transaction_type || response.data.transaction_types || response.data.sub_transaction_types || []);
				const sub_filters = sub_type_list.map((item) => {
					if (typeof item === "string") {
						return { label: item, value: item };
					}

					return {
						label: item.label ?? item.name,
						value: item.id ?? item.value
					};
				});
				setSubTransactionFilter(sub_filters);
				setSubTrasactionType(sub_filters.length > 0 ? sub_filters[0] : null);
			} else {
				toast.dismiss();
				toast.error(response.message);
			}
		});
	};


	// List API
	//Systematic Report List
	const _systematicReportListData = () => {
		setFilterApplied(true);
		setApiLoader(true);
		setBtnLoader(true);
		let url = "reports/systematic-report-list";
		let body = {
			"zone": zone !== "" ? zone.value : "",
			"region": region !== "" ? region.value : "",
			"branch": branch !== "" ? branch.value : "",
			"ap": ADMIN_PROFILE_DATA.admin_type_id === 8 ? ADMIN_PROFILE_DATA.admin_mt_id : ap !== "" ? ap.value : "",
			"rmcode": rm !== "" ? rm.value : "",
			"client_search": user,
			"schemename": scheme,
			// "start_date": startDate,
			// "end_date": endDate,
			start_date: startDate === "Start date" ? null : startDate,
			end_date: endDate === "End date" ? null : endDate,
			"foliono": folioNo,
			"report_type": reportType.value,
			"min_amount": minAmount === "" ? null : minAmount,
			"max_amount": maxAmount === "" ? null : maxAmount
		};

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {
				setSipReportData(response.data);
				const total = Math.ceil(response.data.length / 20);
				setTotalPages(total);

				if (response.data.length === 0) {
					toast.dismiss();
					toast.info("No records found for the selected filters");
				}

			} else {
				toast.dismiss();
				toast.error(response.message);
			}
			setApiLoader(false);
			setBtnLoader(false);
		});
	};

	//Transaction Report List
	const _transactionReportListData = () => {
		setFilterApplied(true);
		setApiLoader(true);
		setBtnLoader(true);
		let url = "reports/transaction-statement-list";
		let body = {
			"zone": zone !== "" ? zone.value : "",
			"region": region !== "" ? region.value : "",
			"branch": branch !== "" ? branch.value : "",
			"ap": ADMIN_PROFILE_DATA.admin_type_id === 8 ? ADMIN_PROFILE_DATA.admin_mt_id : ap !== "" ? ap.value : "",
			"rmcode": rm !== "" ? rm.value : "",
			"client_search": user,
			"schemename": scheme,
			// "start_date": startDate,
			// "end_date": endDate,
			start_date: startDate === "Start date" ? "" : startDate,
			end_date: endDate === "End date" ? "" : endDate,
			"foliono": folioNo,
			"transaction_type": transactionType ? transactionType.value : "", //purchase or redemption
			"sub_transaction_type": subTransactionFilter.length > 0 ? subTransactionType.value : null,
			"min_amount": minAmount === "" ? null : minAmount,
			"max_amount": maxAmount === "" ? null : maxAmount
		};
		const currentRequestId = ++transactionRef.current;

		APIService(true, url, body).then(async (response) => {
			if (currentRequestId === transactionRef.current) {
				if (response.status_code === 200) {
					setTransactionReportData(response.data);
					const total = Math.ceil(response.data.length / 20);
					setTotalPages(total)
				} else {
					toast.dismiss();
					toast.error(response.message);
				}
				setApiLoader(false);
				setBtnLoader(false);
			}
		});
	};

	//Transaction Report List
	const _aumReportListData = () => {
		setFilterApplied(true);
		setApiLoader(true);
		setBtnLoader(true);
		let url = "reports/aum-report-list";
		let body = {
			"zone": zone.value,
			"region": region.value,
			"branch": branch.value,
			"ap": ADMIN_PROFILE_DATA.admin_type_id === 8 ? ADMIN_PROFILE_DATA.admin_mt_id : ap !== "" ? ap.value : "",
			"rmcode": rm.value,
			"min_amount": minAmount === "" ? null : minAmount,
			"max_amount": maxAmount === "" ? null : maxAmount
		};

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {
				setAumReportData(response.data);
			} else {
				toast.dismiss();
				toast.error(response.message);
			}
			setApiLoader(false);
			setBtnLoader(false);
		});
	};

	// Download Reports APIS
	// Download - Systematic Report List
	const _downloadSystematicReport = () => {
		let url = "reports/download-systematic-report";
		let body = {
			"zone": zone !== "" ? zone.value : "",
			"region": region !== "" ? region.value : "",
			"branch": branch !== "" ? branch.value : "",
			"ap": ADMIN_PROFILE_DATA.admin_type_id === 8 ? ADMIN_PROFILE_DATA.admin_mt_id : ap !== "" ? ap.value : "",
			"rmcode": rm !== "" ? rm.value : "",
			"client_search": user,
			"schemename": scheme,
			// "start_date": startDate,
			// "end_date": endDate,
			start_date: startDate === "Start date" ? "" : startDate,
			end_date: endDate === "End date" ? "" : endDate,
			"foliono": folioNo,
			"report_type": reportType.value,
			"min_amount": minAmount === "" ? null : minAmount,
			"max_amount": maxAmount === "" ? null : maxAmount
		};

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {
				if (response.data.url) {
					_handleOpenDownloadReportPopup(response.data.url);
				}
			} else {
				toast.dismiss();
				toast.error(response.message);
			}

			setDownloadLoader(false);

		});
	};

	// Download - Transactional Report List
	const _downloadTransactionalReport = () => {
		let url = "reports/transaction-statement-download";
		let body = {
			"zone": zone !== "" ? zone.value : "",
			"region": region !== "" ? region.value : "",
			"branch": branch !== "" ? branch.value : "",
			"ap": ADMIN_PROFILE_DATA.admin_type_id === 8 ? ADMIN_PROFILE_DATA.admin_mt_id : ap !== "" ? ap.value : "",
			"rmcode": rm !== "" ? rm.value : "",
			"client_search": user,
			"schemename": scheme,
			// "start_date": startDate,
			// "end_date": endDate,
			start_date: startDate === "Start date" ? "" : startDate,
			end_date: endDate === "End date" ? "" : endDate,
			"foliono": folioNo,
			"transaction_type": transactionType ? transactionType.value : "", //purchase or redemption
			"sub_transaction_type": subTransactionFilter.length > 0 ? subTransactionType.value : null,
			"min_amount": minAmount === "" ? null : minAmount,
			"max_amount": maxAmount === "" ? null : maxAmount
		};

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {
				if (response.data.url) {
					_handleOpenDownloadReportPopup(response.data.url);
				}
			} else {
				toast.dismiss();
				toast.error(response.message);
			}

			setDownloadLoader(false);

		});
	};

	// Download - Transactional Report List
	const _downloadAUMReport = () => {
		let url = "reports/download-aum-report";
		let body = {
			"zone": zone.value,
			"region": region.value,
			"branch": branch.value,
			"ap": ADMIN_PROFILE_DATA.admin_type_id === 8 ? ADMIN_PROFILE_DATA.admin_mt_id : ap !== "" ? ap.value : "",
			"rmcode": rm.value,
			"min_amount": minAmount === "" ? null : minAmount,
			"max_amount": maxAmount === "" ? null : maxAmount
		};

		APIService(true, url, body).then(async (response) => {
			if (response.status_code === 200) {
				if (response.data.url) {
					_handleOpenDownloadReportPopup(response.data.url);
				}
			} else {
				toast.dismiss();
				toast.error(response.message);
			}

			setDownloadLoader(false);

		});
	};


	// const _validateFilters = () => {

	// 	let newErrors = {};

	// 	if (!zone) {
	// 		newErrors.zone = "Zone is required";
	// 	}

	// 	if (!region) {
	// 		newErrors.region = "Region is required";
	// 	}

	// 	if (!branch) {
	// 		newErrors.branch = "Branch is required";
	// 	}

	// 	if (!rm) {
	// 		newErrors.rm = "RM is required";
	// 	}

	// 	if (startDate === "Start date" || endDate === "End date" || !startDate || !endDate) {
	// 		newErrors.date = "Date range is required";
	// 	}

	// 	setErrors(newErrors);

	// 	if (Object.keys(newErrors).length > 0) {
	// 		toast.dismiss();
	// 		toast.error("Please fill all mandatory fields");
	// 		return false;
	// 	}

	// 	return true;
	// };

	const _handleSubmit = () => {

		if (tabIndex === 1) {
			_systematicReportListData();
		}
		else if (tabIndex === 2) {
			_transactionReportListData();
		}
		else {
			_aumReportListData();
		}
	};

	return (
		<div className="h-100vh">
			<NavigationHeader
				type={2}
				data={PAGE_NAVIGATION}
				title="Manage Reports" />
			<div className="ps-4 pe-lg-5 pe-md-2 pe-2 padding-42px-top h-100">

				<div className="row">
					<div className="col">
						<h4 class="color-black e-font-16 line-height-16px mb-0 e-poppins-medium">
							Reports
						</h4>
					</div>
					<div className="col-12 mt-4">
						<CustomTab type={2}
							index={tabIndex}
							data={NOTIFICATION_TABS}
							onSelectTab={_handleTabChange} />
					</div>
				</div>

				{/* Action button */}
				<div className="row">
					<div className="col">
						<div className="d-flex justify-content-end gap-3">

							<DownloadButton onPress={_handleDownloadReport}
								// disabled={transactionReportData.length > 0 ? false : true}
								loader={downloadLoader} />

							{/* File upload */}
							<input
								type="file"
								id="file"
								accept=".xls,.xlsx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv" ref={fileInputRef}
								onChange={_handleFileUploadChange}
								className="d-none"
							/>
						</div>
					</div>
					<h4 class="color-black e-font-16 line-height-16px mb-0 e-poppins-medium mt-3">
						Filters
					</h4>
				</div>

				{/* Filters */}
				<div className="row mt-4 row-gap-4">

					{
						tabIndex !== 3 &&
						<div className="col-3">
							<div className="position-relative h-100">
								<CustomDateRangePicker
									startDate={startDate}
									endDate={endDate}
									leftAlign={true}
									postfix={'*'}
									// error={errors.date}
									className="h-100"
									leftOffset="left-0 "
									popupRef={popupRef}
									showDateFilter={showDateFilter}
									handleShowDateFilter={_handleShowDateFilter}
									selectedRange={selectedRange}
									handleDateRangeChange={_handleDateRangeChange}
									clearDates={_handleClearDates} />
							</div>
						</div>
					}
					{ADMIN_PROFILE_DATA.admin_type_id < 5 && <div className="col-3">
						<CustomSearchSelectBox options={zoneList}
							value={zone}
							id="zone-dropdown"
							hide_error_text={false}
							postfix={'*'}
							placeholder="Region"
							// error={errors.zone}
							isSearchable={true}
							onSelectChange={_handleZoneSelect} />
					</div>}
					{ADMIN_PROFILE_DATA.admin_type_id < 6 && <div className="col-3">
						<CustomSearchSelectBox options={regionList}
							value={region}
							isDisabled={zone ? false : true}
							id="region-dropdown"
							hide_error_text={false}
							// error={errors.region}
							postfix={'*'}
							placeholder="Zone"
							isSearchable={true}
							onSelectChange={_handleRegionSelect} />
					</div>}
					{ADMIN_PROFILE_DATA.admin_type_id < 7 && <div className="col-3">
						<CustomSearchSelectBox options={branchList}
							value={branch}
							isDisabled={region ? false : true}
							id="branch-dropdown"
							hide_error_text={false}
							// error={errors.branch}
							placeholder="Branch"
							postfix={'*'}
							isSearchable={true}
							onSelectChange={_handleBranchSelect} />
					</div>}
					{ADMIN_PROFILE_DATA.admin_type_id < 8 && <div className="col-3">
						<CustomSearchSelectBox options={rmList}
							value={rm}
							isSearchable={true}
							isDisabled={branch ? false : true}
							id="rm-dropdown"
							hide_error_text={false}
							postfix={'*'}
							// error={errors.rm}
							placeholder="RM"
							onSelectChange={_handleRMSelect} />
					</div>}

					{ADMIN_PROFILE_DATA.admin_type_id !== 8 &&
						<div className="col-3">
							<CustomSearchSelectBox options={associateList}
								value={ap}
								isDisabled={rm ? false : true}
								id="ap-dropdown"
								hide_error_text={false}
								placeholder="AP"
								onSelectChange={_handleAPSelect} />
						</div>
					}

					{tabIndex !== 3 && <div className="col-3">
						<CustomTextInput value={user}
							placeholder="User"
							onEnter={_handleSubmit}
							valueChange={_handleUserSelect} />
					</div>}


					{tabIndex !== 2 && <div className="col-3">
						<CustomTextInput value={scheme}
							placeholder="Scheme"
							onEnter={_handleSubmit}
							valueChange={_handleSchemeSelect} />
					</div>}
					{tabIndex !== 2 && <div className="col-3">
						<CustomTextInput value={folioNo}
							placeholder="Folio No"
							onEnter={_handleSubmit}
							valueChange={_handleFolioNoSelect} />
					</div>}

					{
						(tabIndex === 1) &&
						<div className="col-3">
							<CustomSearchSelectBox options={SIP_REPORT_TYPES}
								value={reportType}
								id="report-type-dropdown"
								hide_error_text={false}
								placeholder="Report Type"
								onSelectChange={(value) => setReportType(value)} />
						</div>
					}

					{
						(tabIndex === 2) &&
						<div className="col-3">
							<CustomSearchSelectBox options={transactionTypesOptions}
								value={transactionType}
								id="transaction-type-dropdown"
								hide_error_text={false}
								placeholder="Transaction Type"
								onSelectChange={_handleTransactionTypeSelect} />
						</div>
					}

					{
						(tabIndex === 2 && subTransactionFilter.length > 0) &&
						<div className="col-3">
							<CustomSearchSelectBox options={subTransactionFilter}
								value={subTransactionType}
								id="transaction-sub-type-dropdown"
								hide_error_text={false}
								placeholder="Sub Transaction Type"
								onSelectChange={(value) => setSubTrasactionType(value)} />
						</div>
					}

					<div className="col-3">
						<CustomAmountInput value={minAmount}
							key={"Min Amount"}
							label="Min amount"
							className=""
							inputClass="bg-transparent e-poppins-semi-bold padding-28px-left  border-radius-8px"
							labelClass=" e-font-14 line-height-26px bg-white"
							handleChange={_handleMinAmountChange} />
					</div>
					<div className="col-3">
						<CustomAmountInput value={maxAmount}
							key={"Max amount"}
							label="Max amount"
							className=""
							inputClass="bg-transparent e-poppins-semi-bold padding-28px-left  border-radius-8px"
							labelClass=" e-font-14 line-height-26px bg-white"
							handleChange={_handleMaxAmountChange} />
					</div>

					{/* <div className="col-3">
						<CustomSearchSelectBox options={CATEGORY_FUND_TYPE}
							value={categoryType}
							id="category-type-dropdown"
							hide_error_text={false}
							placeholder="Category type"
							onSelectChange={_handleCategoryTypeSelect} />
					</div> */}
					<div className="col-3">
						{/* <GradientButton onPress={() => tabIndex === 1 ? _systematicReportListData() : tabIndex === 2 ? _transactionReportListData() : _aumReportListData()}
							loading={btnLoader} /> */}
						<GradientButton
							onPress={_handleSubmit}
							loading={btnLoader}
						/>
					</div>
				</div>

				{/* Systematic Order Report - Table Data */}
				{
					tabIndex === 1 && filterApplied === true &&
					<div className="row mt-5">
						{sipReportData.length !== 0 && <div className="col-12 text-end mb-3 e-table-scroll-indicator d-sm-block d-none">
							<p className="color-outer-space e-poppins-regular e-font-12 mb-0">
								<img draggable={false} src={require('../../Assets/Images/scroll-gif.gif')} alt="scroll"
									width='24px'
									height='24px'
									className='e-rotate-gif' />
								Scroll horizontally for view more  information</p>
						</div>}
						<div className="col-12 position-relative e-admin-list" id="e-table-body">
							{
								apiLoader === true ?
									<div className="ps-4 pe-lg-5 pe-md-2 pe-2 padding-42px-top">
										<div className="row h-80vh">
											<CustomLoader />
										</div>
									</div>
									:
									sipReportData.length !== 0 ?
										<>
											<DataTableContainer columns={SIP_REPORT_COLUMN}
												data={sipReportData}
												customStyles={TABLE_STYLE} />
										</>
										:
										<EmptyScreen />
							}
						</div>
					</div>
				}

				{/* Transactional Report - Table Data */}
				{
					tabIndex === 2 && filterApplied === true &&
					<div className="row mt-3">
						{transactionReportData.length !== 0 && <div className="col-12 text-end mb-3 e-table-scroll-indicator d-sm-block d-none">
							<p className="color-outer-space e-poppins-regular e-font-12 mb-0">
								<img draggable={false} src={require('../../Assets/Images/scroll-gif.gif')} alt="scroll"
									width='24px'
									height='24px'
									className='e-rotate-gif' />
								Scroll horizontally for view more  information</p>
						</div>}
						<div className="col-12 position-relative e-admin-list" id="e-table-body">
							{
								apiLoader === true ?
									<div className="ps-4 pe-lg-5 pe-md-2 pe-2 padding-42px-top">
										<div className="row h-80vh">
											<CustomLoader />
										</div>
									</div>
									:
									transactionReportData.length !== 0 ?
										<div className="col-12 position-relative pt-4">
											<DataTableContainer columns={TRANSACTION_REPORT_COLUMN}
												data={transactionReportData}
												customStyles={TABLE_STYLE} />
											{/* <div className={`d-flex justify-content-end align-items-center position-absolute bottom-16px right-24 w-max-content mt-3`}>
												<Icon icon="pagination-previous" width="24px" height="24px"
													className={pageNumber === 1 ? 'pointer-events-none opacity-4 mx-3' : 'mx-3 cursor-pointer'}
													onClick={_previousPage} />
												<Icon icon="pagination-next" width="24px" height="24px"
													className={pageNumber === totalPages ? 'ms-1 pointer-events-none opacity-4' : 'ms-1 cursor-pointer'}
													onClick={_nextPage} />
											</div> */}
										</div>
										:
										<EmptyScreen />
							}
						</div>
					</div>
				}

				{/* AUM Report  - Table Data */}
				{
					tabIndex === 3 && filterApplied === true &&
					<div className="row mt-3">
						{aumReportData.length !== 0 && <div className="col-12 text-end mb-3 e-table-scroll-indicator d-sm-block d-none">
							<p className="color-outer-space e-poppins-regular e-font-12 mb-0">
								<img draggable={false} src={require('../../Assets/Images/scroll-gif.gif')} alt="scroll"
									width='24px'
									height='24px'
									className='e-rotate-gif' />
								Scroll horizontally for view more  information</p>
						</div>}
						<div className="col-12 position-relative e-admin-list" id="e-table-body">
							{
								apiLoader === true ?
									<div className="ps-4 pe-lg-5 pe-md-2 pe-2 padding-42px-top">
										<div className="row h-80vh">
											<CustomLoader />
										</div>
									</div>
									:
									aumReportData.length !== 0 ?
										<>
											<DataTableContainer columns={AUM_REPORT_COLUMN}
												data={aumReportData}
												customStyles={TABLE_STYLE} />
										</>
										:
										<EmptyScreen />
							}
						</div>
					</div>
				}



			</div>
		</div>
	)
}

export default ManageReport;
